
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 0H4a4 4 0 00-4 4v24a4 4 0 004 4h24a4 4 0 004-4V4a4 4 0 00-4-4z","fill":"#000","fill-opacity":".07"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.75 16A7.75 7.75 0 0116 23.75a7.75 7.75 0 110-15.5c4.28 0 7.75 3.471 7.75 7.75zm-14.5 0A6.748 6.748 0 0016 22.75c3.73 0 6.75-3.022 6.75-6.75 0-3.748-3.043-6.75-6.75-6.75A6.75 6.75 0 009.25 16zm6.99 1.875a.375.375 0 00.375-.375v-.012c0-.607.48-.92 1.013-1.269.663-.433 1.407-.92 1.407-2.087 0-1.577-1.41-2.507-3.045-2.507-1.401 0-2.188.547-2.851 1.398a.374.374 0 00.082.537l.41.286a.374.374 0 00.508-.074c.467-.595.94-.897 1.85-.897 1.24 0 1.796.631 1.796 1.257 0 .603-.471.9-.997 1.231-.667.42-1.423.896-1.423 2.125v.012c0 .207.168.375.375.375h.5zm.635 1.625a.875.875 0 11-1.75 0 .875.875 0 011.75 0z","fill":"#000","fill-opacity":".54"}})])
          )
        }
      }
    